import { Country } from '../data/country.do';

// A list of countries to be displayed at the top of the list.
export const TOP_COUNTRIES: string[] = [
  'CA',
  'DE',
  'DK',
  'ES',
  'FR',
  'GB',
  'IS',
  'NO',
  'PL',
  'SE',
  'US',
];

export function sortCountries(countries: Country[]): Country[] {
  return countries.sort((a: Country, b: Country): number => {
    const aIndex = TOP_COUNTRIES.findIndex(code => code === a.countryCode);
    const bIndex = TOP_COUNTRIES.findIndex(code => code === b.countryCode);
    if (aIndex !== -1) {
      return bIndex !== -1 ? a.name.localeCompare(b.name) : -1;
    } else if (bIndex !== -1) {
      return 1;
    }
    return a.name.localeCompare(b.name);
  });
}
